import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { WorkflowOrientation } from '@formrails/workflow-designer/data-access';

/**
 * Toolbar for workflow-level details and actions: edit the workflow name and
 * description, turn the canvas, create a new workflow, open an existing one,
 * or save the current one.
 */
@Component({
  selector: 'app-workflow-toolbar',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './workflow-toolbar.component.html',
  styleUrl: './workflow-toolbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkflowToolbarComponent {
  readonly name = input('');
  readonly description = input('');
  readonly nodeCount = input(0);
  readonly saving = input(false);
  readonly canSave = input(true);
  readonly hasUnsavedChanges = input(false);
  readonly orientation = input<WorkflowOrientation>('vertical');

  readonly nameChange = output<string>();
  readonly descriptionChange = output<string>();
  readonly createNew = output<void>();
  readonly openExisting = output<void>();
  readonly orientationChange = output<WorkflowOrientation>();
  readonly save = output<void>();
}
